export const PUSH_BALANCE_PACKAGE_ID_RE = /^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+$/;
export const PUSH_BALANCE_PACKAGE_MAX_LEN = 200;
export const PUSH_BALANCE_ALLOWLIST_MAX_ENTRIES = 200;
export const PUSH_BALANCE_TG_MIN_UZS_DEFAULT = 700_000;

export function normalizePushBalancePackageAllowlist(entries: unknown): string[] {
	if (!Array.isArray(entries)) {
		return [];
	}

	const normalized = entries
		.filter((entry): entry is string => typeof entry === 'string')
		.map(entry => entry.trim().toLowerCase())
		.filter(entry => entry.length > 0);

	return [...new Set(normalized)].sort();
}

export function isPushBalancePackageAllowed(packageName: string, allowlist: string[]): boolean {
	const pkg = packageName.trim().toLowerCase();
	if (!pkg) {
		return false;
	}
	return allowlist.includes(pkg);
}

export function parsePushBalancePackageAllowlistText(text: string): string[] {
	return normalizePushBalancePackageAllowlist(text.split(/\r?\n/));
}

export function formatPushBalancePackageAllowlistText(allowlist: string[]): string {
	return normalizePushBalancePackageAllowlist(allowlist).join('\n');
}
